import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 9, viewBox: "0 0 12 9", stroke: "black", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1.5L6 7L11 1.5", strokeWidth: 1.4, strokeLinecap: "round" }));
export default SvgArrowDown;
